import React, { useState, useEffect } from "react";
import { useFirebase } from "../context/firebase.context";

const EventList = () => {
    const { getEvents, deleteEvent } = useFirebase();
    const [events, setEvents] = useState([]);

    // Fetch all events on component mount
    useEffect(() => {
        const fetchEvents = async () => {
            const eventList = await getEvents();
            setEvents(eventList);
        };

        fetchEvents();
    }, [getEvents]);

    // Handle deleting an event
    const handleDeleteEvent = async (eventId, venuePicURL) => {
        try {
            await deleteEvent(eventId, venuePicURL);
            setEvents((prevEvents) => prevEvents.filter((event) => event.id !== eventId));
            console.log("Event deleted successfully.");
        } catch (error) {
            console.error("Error deleting event:", error);
        }
    };

    return (
        <div className="container my-4">
            <h2 className="text-center mb-5">Events</h2>

            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                {events.map((event) => (
                    <div key={event.id} className="col">
                        <div className="card shadow-sm h-100">
                            {event.venuePicURL && (
                                <img src={event.venuePicURL} className="card-img-top" alt="Event Venue" />
                            )}
                            <div className="card-body">
                                <h5 className="card-title text-dark mb-2">{event.venue}</h5>
                                <p className="card-text text-secondary mb-1">
                                    City: <strong>{event.city}</strong>
                                </p>
                                <p className="card-text text-secondary mb-1">
                                    Date: <strong>{event.eventDate}</strong>
                                </p>
                                <p className="card-text text-secondary mb-1">
                                    Start Time: <strong>{event.startTime}</strong>
                                </p>
                                <p className="card-text text-secondary mb-1">
                                    Duration: <strong>{event.duration} hrs</strong>
                                </p>
                                <button
                                    onClick={() => handleDeleteEvent(event.id, event.venuePicURL)}
                                    className="btn btn-danger w-100 mt-3"
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default EventList;
